import styled from "styled-components";
import { Notification } from "@vds/notifications";
import { Body, Micro, Title } from "@vds/typography";
import { TextLink, Button } from "@vds/buttons";
import { DropdownSelect } from "@vds/selects";
import { Modal } from "@vds/modals";
import { Tooltip } from "@vds/tooltips";
import PropTypes from "prop-types";

export const DropdownStyleGlobal = styled.div`
  padding-right: 1.25rem;
  width: 164px;
  font-size: 12px;
  font-family: neue-haas-grotesk-text;
`;
export const DropdownStyleSelect = styled.div`
  padding-right: 1.25rem;
  width: 164px;
  font-size: 12px;
  font-family: neue-haas-grotesk-text;
  select {
    width: 164px;
  }
`;
export const DropdownStyleMargin = styled.div`
  padding-right: 1.25rem;
  width: 150px;
  margin: 0 0 10px 0;
`;
export const Spacer = styled.div`
  margin-top: ${(props) => (props.top ? props.top : "0px")};
  margin-bottom: ${(props) => (props.bottom ? props.bottom : "10px")};
  ${(props) => props.width && "width: " + props.width};
`;
export const MarginWrapper = styled.div`
  margin-top: 0.75em;
  margin-bottom: 0.75em;
  @media (min-width: 680px) {
    margin-right: 0.75rem;
  }
`;
export const SmallText = (props) => (
  <MarginWrapper>
    <Micro {...props}></Micro>
  </MarginWrapper>
);
export const MediumText = (props) => (
  <MarginWrapper>
    <Body size="small" {...props}></Body>
  </MarginWrapper>
);
export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  button {
    margin: 12px 16px 16px;
  }
  @media (min-width: 768px) {
    justify-content: space-around;
  }
  @media (max-width: 768px) {
    button {
      justify-content: center;
      width: 100%;
    }
  }
`;
export const NotificationBox = styled(Notification)`
  max-height: 20px !important;
  min-height: 20px !important;
  width: 70% !important;
  overflow: visible;
  position: fixed !important;
  top: 89px;
  left: 24.2%;
  z-index: 999;

  @media (min-width: 1280px) {
    left: 24%;
  }
  @media (min-width: 1366px) {
    left: 23%;
  }
  @media (min-width: 1680px) {
    left: 24.5%;
    width: 65% !important;
  }
  @media (min-width: 1920px) {
    left: 28%;
    width: 57% !important;
  }
  @media (min-width: 2304px) {
    left: 32%;
    width: 47% !important;
  }
  @media (min-width: 2560px) {
    left: 33.2%;
    width: 44% !important;
  }
  @media (min-width: 2880px) {
    left: 35%;
    width: 39% !important;
  }
  @media (min-width: 3072px) {
    left: 36%;
    width: 36.5% !important;
  }
  @media (min-width: 3840px) {
    left: 38.5%;
    width: 29% !important;
  }
  @media (min-width: 4096px) {
    left: 39.5%;
    width: 27.5% !important;
  }
  @media (min-width: 5120px) {
    left: 41.7%;
    width: 22% !important;
  }
`;

export const NotificationBoxMax = styled(Notification)`
  max-height: 20px !important;
  min-height: 20px !important;
  width: 80% !important;
  overflow: visible;
  position: fixed !important;
  top: 89px;
  left: 21%;
  z-index: 100;

  @media (max-width: 679px) {
    left: 0%;
    width: 100% !important;
  }
  @media (min-width: 680px) {
    width: 60% !important;
  }
  @media (min-width: 1280px) {
    left: 21%;
  }
  @media (min-width: 1680px) {
    left: 14%;
    width: 83% !important;
  }
  @media (min-width: 1800px) {
    left: 20%;
  }
  @media (min-width: 1920px) {
    left: 17%;
    width: 90% !important;
  }
  @media (min-width: 2050px) {
    left: 20%;
    width: 90% !important;
  }
  @media (min-width: 2304px) {
    left: 22%;
    width: 56% !important;
  }
  @media (min-width: 2560px) {
    left: 25%;
    width: 52% !important;
  }
  @media (min-width: 2880px) {
    left: 27%;
    width: 49% !important;
  }
  @media (min-width: 3072px) {
    left: 29%;
    width: 45% !important;
  }
  @media (min-width: 3840px) {
    left: 33.5%;
    width: 42% !important;
  }
  @media (min-width: 4096px) {
    left: 34%;
    width: 40.5% !important;
  }
  @media (min-width: 5120px) {
    left: 37%;
    width: 39% !important;
  }
`;

export const NotificationBoxBanner = styled(Notification)`
  max-height: 20px !important;
  min-height: 20px !important;
  width: 100% !important;
  overflow: visible;
  position: fixed !important;
  top: 71px;

  @media (min-width: 1680px) {
    left: 14%;
    width: 83% !important;
  }
  @media (min-width: 1920px) {
    left: 17%;
    width: 90% !important;
  }
  @media (min-width: 2304px) {
    left: 22%;
    width: 56% !important;
  }
  @media (min-width: 2560px) {
    left: 25%;
    width: 52% !important;
  }
  @media (min-width: 2880px) {
    left: 27%;
    width: 49% !important;
  }
  @media (min-width: 3072px) {
    left: 29%;
    width: 45% !important;
  }
  @media (min-width: 3840px) {
    left: 33.5%;
    width: 42% !important;
  }
  @media (min-width: 4096px) {
    left: 34%;
    width: 40.5% !important;
  }
  @media (min-width: 5120px) {
    left: 37%;
    width: 39% !important;
  }
`;

export const theme = {
  _2XSmall: "0.5rem", //8px
  XSmall: "0.625rem", //10px
  extraSmall: "0.75rem", //12px
  small: "0.875rem", //14px
  medium: "1rem", //16px
  large: "1.125rem", //18px
  extraLarge: "1.25rem", //20px
  _XLarge: "1.5rem", //24px
  _2XLarge: "1.75rem", //28px
  _3XLarge: "1.875rem", //30px
  _4XLarge: "2rem", //32px
  _5XLarge: "2.125rem", //34px
  _6XLarge: "2.25rem", //36px
  _7XLarge: "2.5rem", //40px
  _8XLarge: "3rem", //48px

  fontFamily1: "neue-haas-grotesk-display",
  fontFamily2: "neue-haas-grotesk-text",
};

export const CustomDropdownSelect = styled(DropdownSelect)`
  height: 1.8rem;
  margin-left: 0.5rem;
  margin-top: 2.5rem;
  & button {
    border-bottom: none;
    & div {
      & div:first-child {
        overflow: unset;
        & p {
          font-size: ${({ theme }) => theme.medium};
        }
      }
      & div:nth-child(2) {
        padding-left: 0.5rem;
      }
    }
  }
  & ul {
    width: 100%;
    & li {
      & span {
        font-size: ${({ theme }) => theme.small};
      }
    }
  }
`;

export const Link = styled(TextLink)`
  font-size: ${(props) => props.fontSize};
  margin-top: ${(props) => props.marginTop};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-bottom: ${(props) => props.marginBottom};
  font-family: ${(props) => props.fontFamily};
  letter-spacing: normal;
  @media (min-width: 1024px) {
    font-size: 0.875rem;
    border-bottom: 1px solid #000000 !important;
    color: #000000;
    &:hover {
      border-bottom: 2px solid #0077b4 !important;
    }
    &:active {
      color: #0077b4;
      border-bottom: 1px solid #0077b4 !important;
    }
    &:focus {
      border-radius: 2px;
      outline: 2px solid #0077b4 !important;
    }
    ::after {
      border: none !important;
    }
  }
`;

export const Img = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-top: ${(props) => props.marginTop};
  z-index: ${(props) => props.zIndex};
`;

function getFontWeight(props) {
  if (props.fontWeight) {
    return props.fontWeight;
  }
  if (props.bold) {
    return "bold";
  }
  return "";
}

export const Wrapper = styled.div`
  align-items: ${(props) => props.alignItems};
  align-content: ${(props) => props.alignContent};
  align-self: ${(props) => props.alignSelf};
  background: ${(props) => props.background};
  background-color: ${(props) => props.backgroundColor};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
  border-style: ${(props) => props.borderStyle};
  border-top: ${(props) => props.borderTop};
  border-bottom: ${(props) => props.borderBottom};
  border-width: ${(props) => props.borderWidth};
  border-color: ${(props) => props.borderColor};
  bottom: ${(props) => props.bottom};
  box-shadow: ${(props) => props.borderShadow};
  color: ${(props) => props.color};
  cursor: ${(props) => (props.cursor ? "pointer" : "")};
  display: ${(props) => props.display};
  flex: ${(props) => props.flex};
  flex-basis: ${(props) => props.flexBasis};
  flex-direction: ${(props) => props.flexDirection};
  flex-flow: ${(props) => props.flexFlow};
  flex-grow: ${(props) => props.flexGrow};
  flex-wrap: ${(props) => (props.flexWrap ? props.flexWrap : "wrap")};
  font-family: ${(props) =>
    props.fontFamily === "neue-haas-grotesk-text" || props.fontFamily ? "neue-haas-grotesk-text" : "neue-haas-grotesk-display"};
  font-size: ${(props) => props.fontSize};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : "")};
  font-weight: ${(props) => getFontWeight(props)};
  column-gap: ${(props) => props.columnGap};
  gap: ${(props) => props.gap};
  grid-template-columns: ${(props) => props.gridTemplateColumns};
  grid-column: ${(props) => props.gridColumn};
  grid-row: ${(props) => props.gridRow};
  grid-row-gap: ${(props) => props.gridRowGap};
  grid-column-gap: ${(props) => props.gridColumnGap};
  height: ${(props) => props.height};
  justify-content: ${(props) => props.justifyContent};
  justify-items: ${(props) => props.justifyItems};
  left: ${(props) => props.left};
  letter-spacing: ${(props) => props.letterSpacing};
  line-height: ${(props) => props.lineHeight};
  margin: ${(props) => props.margin};
  margin-top: ${(props) => props.marginTop};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-bottom: ${(props) => props.marginBottom};
  min-height: ${(props) => props.minHeight};
  max-height: ${(props) => props.maxHeight};
  max-width: ${(props) => props.maxWidth};
  padding: ${(props) => props.padding};
  padding-top: ${(props) => props.paddingTop};
  padding-left: ${(props) => props.paddingLeft};
  padding-right: ${(props) => props.paddingRight};
  padding-bottom: ${(props) => props.paddingBottom};
  position: ${(props) => props.position};
  right: ${(props) => props.right};
  text-align: ${(props) => props.textAlign};
  overflow-wrap: ${(props) => props.overFlowWrap};
  top: ${(props) => props.top};
  width: ${(props) => props.width};
  z-index: ${(props) => props.zIndex};

  & label {
    & p {
      & span {
        display: ${(props) => props.hideOptional};
      }
    }
  }

  @media (min-width: 1024px) {
    font-family: "neue-haas-grotesk-text";
  }

  &:focus {
    outline: none;
  }
`;

export const TextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")} !important;
  margin-left: ${(props) => props.marginLeft};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : "")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
  color: ${(props) => (props.color ? props.color : "black")};
  text-decoration-line: ${(props) => props.textDecorationLine};
  text-align: ${(props) => props.textAlign};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  letter-spacing: initial;
  word-break: ${(props) => (props.wordBreak ? props.wordBreak : "")};
  white-space: ${(props) => (props.whiteSpace ? props.whiteSpace : "")};
  overflow-wrap: ${(props) => props.overFlowWrap};
  &:focus-visible {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const TextWrapperSpan = styled.span`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : "")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
  color: ${(props) => (props.color ? props.color : "black")};
  text-decoration-line: ${(props) => props.textDecorationLine};
  padding: ${(props) => (props.padding ? props.padding : "")};
  margin: ${(props) => (props.margin ? props.margin : "")};
  width: ${(props) => (props.width ? props.width : "")};
  vertical-align: ${(props) => props.verticalAlign};
  margin-left: ${(props) => props.marginLeft};
  &:hover {
    cursor: ${(props) => props.isLink && "pointer"};
    text-decoration-thickness: ${(props) => props.isLink && "2px"};
  }
  &:focus {
    ${(props) =>
      props.isLink &&
      `
    border-radius: 2px;
    border: 2px solid #006fc1; /* Add a 2px border with #006FC1 color */
    outline: none; /* Remove default browser outline */
  `}
  }
  &:active {
    ${(props) =>
      props.isLink &&
      `
    border: none; /* Remove the border when active */
    outline: none; /* Ensure no outline is shown */
    text-decoration-thickness: 0px; /* Remove underline when active */
  `}
  }
`;

export const FlexRow = (props) => <Wrapper display="flex" flexDirection="row" {...props} />;
export const FlexColumn = (props) => <Wrapper display="flex" flexDirection="column" {...props} />;
export const TitleWrapper = (props) => (
  <Wrapper {...props}>
    <Title size={props.size} bold={props.bold}>
      {props.children}
    </Title>
  </Wrapper>
);

TitleWrapper.propTypes = {
  size: PropTypes.string,
  bold: PropTypes.bool,
  children: PropTypes.node,
};

export const BodyWrapper = (props) => (
  <Wrapper {...props}>
    <Body size={props.size} bold={props.bold}>
      {props.children}
    </Body>
  </Wrapper>
);

BodyWrapper.propTypes = {
  size: PropTypes.string,
  bold: PropTypes.bool,
  children: PropTypes.node,
};

export const MicroWrapper = (props) => (
  <Wrapper {...props}>
    <Micro size={props.size} bold={props.bold}>
      {props.children}
    </Micro>
  </Wrapper>
);

MicroWrapper.propTypes = {
  size: PropTypes.string,
  bold: PropTypes.bool,
  children: PropTypes.node,
};

export const MainSection = styled(FlexRow)`
  position: relative;
  height: 100%;
  width: 100%;
  top: 5rem;
`;

export const LeftSection = styled(FlexColumn)`
  position: fixed;
  width: 256px;
  height: 100%;
  background-color: #f6f6f6;
  max-width: 256px;
`;

export const RightSection = styled.div`
  max-width: 1104px;
  @media (min-width: 1024px) {
    width: 100%;
    margin-right: 1rem;
    margin-left: 296px;
    margin-top: ${(props) => props.marginTop};
    padding-left: 0rem;
  }
  @media (max-width: 1023px) {
    margin: 4.5rem 1rem 0 1rem;
  }
  @media (max-width: 390px) {
    width: ${(props) => (props.billingAndPaymentPage && props.userLanguage !== "en-US" ? "91%" : "100%")};
  }
  @media (min-width: 391px) and (max-width: 420px) {
    width: ${(props) => (props.billingAndPaymentPage && props.userLanguage !== "en-US" ? "92%" : "100%")};
  }
  @media (min-width: 421px) and (max-width: 480px) {
    width: ${(props) => (props.billingAndPaymentPage && props.userLanguage !== "en-US" ? "93%" : "100%")};
  }
  width: 100%;
  margin: 4.5rem 1rem 0 1rem;
`;

//navigation items styling
export const NavigationItem = styled.a`
  border-left: ${(props) =>
    props.billing === props.index || props.cases === props.index || props.myContract === props.index || props.technicianAppointments === props.index
      ? "0.25rem solid #d0021b"
      : "0.25rem solid transparent"};
  font-weight: ${(props) =>
    props.billing === props.index || props.cases === props.index || props.myContract === props.index || props.technicianAppointments === props.index
      ? "bold"
      : "normal; "};
  background: ${(props) =>
    props.billing === props.index || props.cases === props.index || props.myContract === props.index || props.technicianAppointments === props.index
      ? "white"
      : ""};
  font-family: "neue-haas-grotesk-text";
  margin-top: ${(props) => props.marginTop};
  padding-left: 0.68rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 2.8rem;
  cursor: pointer;
  font-size: 0.875rem;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: none;
    color: inherit;
  }
  &:focus {
    text-decoration: none;
    color: inherit;
  }
  &:active {
    text-decoration: none;
    color: inherit;
  }
  &:focus-visible {
    outline: solid;
  }
  @media (min-width: 767px) {
    font-family: "neue-haas-grotesk-text";
  }
`;

export const Header = styled.div`
  border-style: solid;
  border-width: 0 0 0.063rem 0;
  border-color: #dedede;
  padding-top: 0;
  position: fixed;
  width: 100vw;
  height: ${(props) => (props.height ? props.height : "5rem")};
  z-index: 999;
  background-color: #ffffff;
`;
export const PageTitle = styled(Title)`
  // & h3 {
  //   font-size: ${({ theme }) => theme.XLarge};
  // }
  // @media (min-width: 680px) {
  & h3 {
    font-size: ${({ theme }) => theme._4XLarge};
  }
  // }
`;

export const AccountProfile = styled(Wrapper)`
  // @media (min-width: 376px) {
  .headingTitle {
    font-size: ${({ theme }) => theme._XLarge};
  }
  .row1 {
    margin-top: 0.5rem;
  }
  .row2 {
    margin-top: 0;
  }
  .column1 {
    margin-top: 1rem;
    flex: 100%;
  }
  .column2 {
    margin-top: 1rem;
    flex: 100%;
  }
  // }
  @media (min-width: 1024px) {
    .headingTitle {
      font-size: ${({ theme }) => theme._4XLarge};
    }
    .row1 {
      margin-top: 0rem;
    }

    .row2 {
      margin-top: 1rem;
    }
    .column1 {
      flex: 1;
      margin-top: 0;
      flex-basis: 50%;
    }
    .column2 {
      flex: 2;
      margin-top: 0;
      flex-basis: 50%;
    }
  }
`;

export const SupportCases = styled(Wrapper)`
  .subHeading {
    font-size: ${({ theme }) => theme.extraSmall};
  }
  @media (min-width: 680px) {
    .subHeading {
      font-size: ${({ theme }) => theme.small};
    }
  }
`;

export const ModalTextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : "")};
`;

export const CustomisedButton = styled(Button)`
  width: ${(props) => (props.buttonWidth ? props.buttonWidth : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "1rem")};
  cursor: ${(props) => (props.disabled ? "auto" : "pointer")};
  & span {
    color: ${(props) => (props.secondary && props.disabled ? "#bbbfbf" : "")};
    font-size: 0.75rem;
  }
`;

export const ModalBox = styled(Modal)`
@media (max-width: 1023px) {
  min-height: ${(props) => props.mobHeight};
  height: ${(props) => props.mobHeight};
  max-height: ${(props) => props.mobMaxHeight};
  width: ${(props) => props.mobWidth};
  max-width: ${(props) => props.mobMaxWidth};
  padding-top: ${(props) => props.mobPaddingTop};
  & div {
    padding-top:${(props) => props.mobBodyPaddingTop};
    & div {
      padding-top:${(props) => props.mobBodyPaddingTop};
    }
  }
  & footer {
    padding:${(props) => props.mobFooterPadding};
  }
 }

  @media (min-width: 1024px) {
    min-height: ${(props) => props.height};
    height: ${(props) => props.height};
    max-height: ${(props) => props.maxHeight};
    width: ${(props) => props.width};
    max-width: ${(props) => props.maxWidth};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  width: ${(props) => (props.width ? props.width : "")};
  padding: 1.5rem;
  padding: ${(props) => (props.padding ? props.padding : "")};
  box-shadow: ${(props) =>
    props.boxShadow ? "0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2)" : ""};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "")};
  & div {
    & div {
      & div {
        & footer {
          padding-top: ${(props) => (props.modalFooterPaddingTop ? props.modalFooterPaddingTop : "")};
          margin-left: auto;
          width: ${(props) => (props.modalFooterWidth ? props.modalFooterWidth : "")};
          & div {
            & div {
              & button {
                & span {
                  font-size: 0.875rem;
                }
              }
            }
          }
        }
        & div {
          padding-top: ${(props) => (props.modalBodyPaddingTop ? props.modalBodyPaddingTop : "")};
        }
      }
    
  }
`;

export const CustomModal = styled(Modal)`
  min-height: ${(props) => props.mobHeight};
  height: ${(props) => props.mobHeight};
  max-height: ${(props) => props.mobMaxHeight};
  width: ${(props) => props.mobWidth};
  max-width: ${(props) => props.mobMaxWidth};
  @media (min-width: 680px) {
    // padding-top: 1.5rem;
    // padding-bottom: 0;
    // line-height: 1.35rem;
    min-height: ${(props) => props.height};
    height: ${(props) => props.height};
    max-height: ${(props) => props.maxHeight};
    width: ${(props) => props.width};
    max-width: ${(props) => props.maxWidth};
  }
`;

export const RedesignedModalBox = styled(Modal)`
  height: ${(props) => props.height};
  min-height: ${(props) => props.height};
  width: ${(props) => props.width};
  box-shadow: 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 24px;
  .footer {
    padding-top: ${(props) => props.footerPadding};
  }
`;

export const IdleSessionTimerModal = styled(Modal)`
  min-height: ${(props) => props.mobHeight};
  height: ${(props) => props.mobHeight};
  max-height: ${(props) => props.mobMaxHeight};
  width: ${(props) => props.mobWidth};
  max-width: ${(props) => props.mobMaxWidth};
  padding: 1rem;
  & h2 {
    font-size: 1.25rem;
    font-family: neue-haas-grotesk-display;
  }
  & h4 {
    font-size: 0.75rem;
    font-family: neue-haas-grotesk-text;
  }
  .footer {
    flex-wrap: wrap;
    .btn-1 {
      flex: 100%;
      & :last-child {
        padding-left: 0rem;
        padding-right: 0rem;
      }
    }
    .btn-2 {
      margin-top: 1rem;
      flex: 100%;
    }
  }
  @media (min-width: 680px) {
    min-height: ${(props) => props.height};
    height: ${(props) => props.height};
    max-height: ${(props) => props.maxHeight};
    width: ${(props) => props.width};
    max-width: ${(props) => props.maxWidth};
    .footer {
      margin-top: 1rem;
      justify-content: space-between;
      .btn-1 {
        flex: 0;
        & :last-child {
          padding-left: 2.75rem;
          padding-right: 2.75rem;
        }
      }
      .btn-2 {
        flex: 0.9;
        margin-top: 0;
      }
    }
  }
`;

export const CustomisedModal = styled(Modal)`
  min-height: ${(props) => props.mobHeight};
  height: ${(props) => props.mobHeight};
  max-height: ${(props) => props.mobMaxHeight};
  width: ${(props) => props.mobWidth};
  max-width: ${(props) => props.mobMaxWidth};
  box-shadow: 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: ${(props) => (props.padding ? props.padding : "24px 24px 24px 18px")};
  & h2 {
    font-family: "neue-haas-grotesk-display";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  }
  & h4 {
    font-family: "neue-haas-grotesk-text";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  .footer {
    display: flex;
    width: 100%;
    justify-content: end;
  }
`;

export const CustomTooltip = styled(Tooltip)`
  font-size: 0.75rem;
  font-weight: 100;
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  & span {
    & span {
      word-break: break-word;
      left: ${(props) => props.left};
      & div {
        width: 100%;
        height: auto;
      }
    }
  }
`;

export const StyledImage = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-top: ${(props) => props.marginTop};
`;

export const SortIconStyle1 = styled.img`
  width: 0.75rem;
  position: relative;
  top: 0.15rem;
  left: 0.25rem;
  @media (max-width: 1023px) {
    top: 0.01rem;
    width: 0.625rem;
  }
  @media (min-width: 1280px) {
    top: ${(props) => (props.top ? props.top : "")};
  }
`;

export const SortIconStyle = styled.img`
  width: 0.75rem;
  position: relative;
  top: 0.15rem;
  left: 0.25rem;
  @media (max-width: 1023px) {
    top: 0.01rem;
    width: 0.625rem;
  }
  @media (min-width: 1280px) {
    top: ${(props) => (props.top ? props.top : "")};
  }
`;

export const SortIconStylePayment = styled.img`
  width: 0.875rem;
  position: relative;
  top: 0.25rem;
  left: 0.3125rem;
  // float: right;
  @media (max-width: 1023px) {
    width: 0.625rem;
    top: 2px;
  }
`;

export const SortIconStyle_1_Payment = styled.img`
  width: 0.6875rem;
  position: relative;
  top: 0.1875rem;
  left: 0.3125rem;
  // float: right;
  @media (max-width: 679px) {
    width: 0.625rem;
  }
`;

export const CustomWrapper = styled.div`
  display: ${(props) => (props.display ? props.display : "")};
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "")};
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : "")};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  background: ${(props) => (props.background ? props.background : "")};
  color: ${(props) => (props.fontColor ? props.fontColor : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  height: ${(props) => (props.height ? props.height : "")};
  width: ${(props) => (props.width ? props.width : "")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "")};
  min-width: ${(props) => (props.minWidth ? props.minWidth : "")};
  & label {
    & p {
      & span {
        display: ${(props) => (props.hideOptional ? props.hideOptional : "")};
      }
    }
  }
  & svg {
    @media (max-width: 679px) {
      min-width: 1.5rem;
      min-height: 1.5rem;
    }
  }
`;

export const CustomisedErrorNotification = styled(Notification)`
  & div {
    height: 1rem;
    min-height: ${(props) => (props.minHeight ? props.minHeight : "")};
    & div {
      flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "")};
      & div {
        & svg {
          min-width: 0.75rem;
          max-width: 0.75rem;
        }
      }
      & div:not(:first-child) {
        margin-top: 0.2rem;
      }
      & button {
        & svg {
          min-width: 0.75rem;
          max-width: 0.75rem;
        }
      }
    }`;

function getButtonPadding(props) {
  if (props.boxButton) {
    return props.padding ? props.padding : "12px 16px 12px 16px";
  }
  return "";
}

function getButtonTextColor(props) {
  if (props.disabled) {
    return "#aeaeae";
  }
  if (props.secondary) {
    return "black";
  }
  return "white";
}

export const CPButton = styled(Button)`
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  width: ${(props) => (props.buttonWidth ? props.buttonWidth : "")};
  height: ${(props) => (props.buttonHeight ? props.buttonHeight : "40px")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
  box-shadow: ${(props) => (props.secondary && props.boxButton ? "2px 2px 5px 1px rgba(0, 0, 0, 0.1)" : "")};
  border-radius: ${(props) => (props.boxButton ? "0.25rem" : "")};
  border: ${(props) => (props.boxButton ? "white" : "")};
  cursor: ${(props) => (props.disabled ? "auto" : "pointer")};
  padding: ${(props) => getButtonPadding(props)};
  text-transform: ${(props) => (props.boxButton ? "uppercase" : "")};
  background-color: ${(props) => props.secondary && "#ffffff"};
  & span {
    color: ${(props) => getButtonTextColor(props)};
    font-size: ${(props) => (props.boxButton && props.fontSize ? props.fontSize : "0.875rem")};
    font-family: ${(props) => (props.boxButton ? "neue-haas-grotesk-text" : "")};
    padding: 0;
    text-overflow: unset;
  }
  &:hover {
    color: ${(props) => (props.secondary ? "#000000" : "#FFFFFF")};
    background: ${(props) => (props.secondary ? "#FFFFFF" : "#747474")};
    border: ${(props) => (props.secondary ? "#FFFFFF" : "")};
    box-shadow: ${(props) => (props.secondary ? "0px 2px 5px 0px rgba(0, 0, 0, 0.3) !important" : "unset !important")};
    &:before {
      outline: none !important;
    }
  }
  &:active {
    color: #ffffff !important;
    background: #b5b5b5 !important;
    box-shadow: unset !important;
  }
  &:focus {
    color: ${(props) => (props.secondary ? "#000000" : "#FFFFFF")};
    background: ${(props) => (props.secondary ? "#FFFFFF" : "#000000")};
    outline: 2px solid #0077b4 !important;
    &:before {
      outline: none !important;
    }
  }
  &:disabled {
    cursor: auto;
    color: #aeaeae;
    background: #e0e0e0;
    box-shadow: unset;
  }
  &:before {
    border: none !important;
    outline: none !important;
  }
`;

export const CustomisedTextLink = styled(TextLink)`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  width: ${(props) => (props.width ? props.width : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  color: #0077b4;
  border-bottom: 1px solid #0077b4;
  &:hover {
    border-bottom: 2px solid #0077b4;
  }
  &:active {
    color: #0077b4;
    border-bottom: 1px solid #0077b4;
  }
  &:focus {
    border-radius: 2px;
    outline: 2px solid #0077b4 !important;
  }
  ::after {
    border: none !important;
  }
`;

export const CustomisedTertiaryButton = styled(Button)`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: bold;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
  width: ${(props) => props.buttonWidth};
  height: ${(props) => (props.buttonHeight ? props.buttonHeight : "40px")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "16px")};
  text-align: center;
  text-transform: uppercase;
  color: #0077b4;
  background: transparent;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0.25rem;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  & span {
    padding: 12px 16px;
    text-overflow: unset;
  }
  &:hover {
    color: #0077b4;
    background: #ceeeff;
    border: 0;
  }
  &:active,
  &:active:focus {
    color: #0077b4;
    background: #7bbce1 !important;
    outline: none !important;
    border: 0;
  }
  &:focus {
    color: #0077b4;
    background: #ffffff;
    outline: ${(props) => (props.outline ? props.outline : " 2px")} solid #0077b4 !important;
  }
  &:disabled {
    color: #aeaeae;
    background: #e0e0e0;
    cursor: auto;
  }
  &:before {
    border: none !important;
    outline: none !important;
  }
`;

export const CustomisedTitle = styled.div`
  & h3 {
    font-family: "neue-haas-grotesk-display";
    font-style: normal;
    font-weight: 700;
    font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
    line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
    word-break: break-word;
  }
`;

export const IconWrapper = styled.button`
  width: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  position: relative;
  outline: none;

  &:hover::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.04);
    z-index: 0;
  }

  &:active::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.12);
    z-index: 0;
  }

  &:focus::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff;
    outline: 2px solid #0077b4;
    z-index: 0;
  }
`;

const StyledButton = styled.button`
  width: 36px;
  height: 24px;
  margin-right: ${(props) => (props.windowSize <= 400 && props.userLanguage === "pl-PL" ? "10px" : "24px")};
  margin-left: ${(props) => (props.windowSize <= 400 && props.userLanguage === "pl-PL" ? "10px" : "24px")};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;

export const CustomisedBackPath = ({ onClick, userLanguage, windowSize, src, ...props }) => (
  <StyledButton type="button" userLanguage={userLanguage} windowSize={windowSize} onClick={onClick} aria-label="Back" {...props}>
    <img src={src} alt="Back" />
  </StyledButton>
);

CustomisedBackPath.propTypes = {
  onClick: PropTypes.func,
  userLanguage: PropTypes.string,
  windowSize: PropTypes.number,
  src: PropTypes.string,
};

export const FullScreenModalButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 16px;
  padding: 12px 5% 12px 0;
  width: 100%;
  @media (min-width: 481px) and (max-width: 679px) {
    padding: 12px 3% 15px 0;
  }
  @media (max-width: 480px) {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
    padding: 12px 16px 16px 16px;
  }
`;

export const CaseNumberTextLink = styled(TextLink)`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0077b4;
  border-bottom: 1px solid #0077b4;
  &:hover {
    border-bottom: 2px solid #0077b4;
  }
  &:active {
    color: #0077b4;
    border-bottom: 1px solid #0077b4;
  }
  &:focus {
    border-radius: 2px;
    outline: 2px solid #0077b4 !important;
  }
  ::after {
    border: none !important;
  }
`;

export const CustomLoader = styled.div`
  & div {
    z-index: 1;
    & div {
      width: 18px;
      height: 18px;
    }
  }
`;

export const StyledBlueAnchorTag = styled.a`
  color: #006fc1;
  text-decoration-line: underline;
  font-family: "neue-haas-grotesk-text";
  font-size: 0.875rem;
  cursor: pointer;
  &:hover {
    text-decoration-thickness: 2px;
  }
  &:active {
    color: #0077b4;
    text-decoration-thickness: 1px;
  }
  &:focus {
    border-radius: 2px;
    outline: 2px solid #0077b4 !important;
  }
  ::after {
    border: none !important;
  }
`;

export const StyledAnchorTag = styled.a`
  text-decoration-line: underline;
  font-family: "neue-haas-grotesk-text";
  font-size: 0.875rem;
  cursor: pointer;
  &:hover {
    text-decoration-thickness: 2px;
  }
  &:active {
    text-decoration-thickness: 1px;
  }
  &:focus {
    border-radius: 2px;
    outline: 2px solid #0077b4 !important;
  }
  ::after {
    border: none !important;
  }
`;
